import LiveOutcomesTable from '~/web-frontend-core/api/connector/outcomes/live/Table';
import LiveOutcomesTableMobile from '~/web-frontend-core/api/connector/outcomes/live/TableMobile';
import { COLUMN_WIDTH, LOCK_STATE, SITE_TYPE } from '~/web-frontend-core/api/const/base';
import { objectEntries, objectFromEntries } from '~/web-frontend-core/base/lib';
import Logger from '~/web-frontend-core/devtools/logger';
import { AllMobileCategories } from '~/web-frontend-core/store/line/outcomes.mobile/additional/categories/All.mobile';
import { CategoriesTypes } from '~/web-frontend-core/store/line/outcomes.mobile/additional/categories/Types.mobile';
import FavoriteCategories from '~/web-frontend-core/store/line/outcomes/additional/categories/Favorite';
import OutcomesTables from '~/web-frontend-core/store/line/outcomes/additional/Tables';
import HeadTable from './outcomes/HeadTable';
import LineOutcomesTableMobile from '~/web-frontend-core/api/connector/outcomes/line/TableMobileLine';
export class OutcomesBase {
    constructor(cfg) {
        this.subscribedIDs = new Set();
        this.update = this.update.bind(this);
        this.listenWS = this.listenWS.bind(this);
        this.stopListenWS = this.stopListenWS.bind(this);
        this.onmessage = this.onmessage.bind(this);
        this.width = cfg.width || COLUMN_WIDTH.MEDIUM;
        this.tables = new OutcomesTables(this.width);
        this.statistical_tables = new OutcomesTables(this.width);
        this.statistic_types = new CategoriesTypes();
        this.headTable = new HeadTable(this.width);
        this.statistical_categories = new AllMobileCategories(this.width, this.statistical_tables.select);
        this.categories = new AllMobileCategories(this.width, this.tables.select);
    }
    setWidth(width) {
        this.width = width;
        this.tables.setWidth(width);
        this.headTable.width = width;
        this.categories.width = width;
    }
    //#region wss
    /**
     * Подписка на обновления таблицы live доп.исходов через WS
     */
    listenWS(subscriptionID) {
        if (this.isSubscribed(subscriptionID)) {
            return Promise.resolve(subscriptionID);
        }
        const logger = Logger.getInstance();
        return new Promise((resolve, reject) => {
            this.wsListener.subscribe({
                onopen() { resolve(subscriptionID); },
                onerror(e) { reject(e); },
                id: subscriptionID,
                subscriptionID,
                onmessage: this.onmessage,
            });
        }).then((subscriptionID) => {
            logger.log(`[WebSocket: Допроспись ${subscriptionID}] Соединение открыто`);
            this.subscribedIDs.add(subscriptionID);
            return subscriptionID;
        }).catch((e) => {
            logger.error(e);
            this.stopListenWS(subscriptionID);
            this.deleteGame(subscriptionID);
            throw e;
        });
    }
    onmessage(data) {
        if ('notExists' in data) {
            this.stopListenWS(data.id);
            /**
             * Событие завершилось, не удаляем, только чистим данные,
             * чтобы скрыть и не грузить по XHR
             */
            this.clearGame(data.id);
            Logger.getInstance().error(new Error(`[OutcomesBase] Событие ${data.id} не существует!`));
            return;
        }
        Logger.getInstance().log(`[OutcomesBase: Допроспись ${data.id}] обновлена`);
        this.update(data.id, data);
    }
    isSubscribed(subscriptionID) {
        return this.subscribedIDs.has(subscriptionID);
    }
    stopListenWS(subscriptionID) {
        if (!this.subscribedIDs.delete(subscriptionID)) {
            return Promise.resolve();
        }
        Logger.getInstance().log(`[WebSocket] Отписка от обновлений ${subscriptionID} допросписи`);
        this.wsListener.unsubscribe({ subscriptionID });
        return Promise.resolve();
    }
    stopListenAllWS() {
        Logger.getInstance().log('[WebSocket] Отписка от всех обновлений допросписи');
        this.subscribedIDs.forEach(this.stopListenWS);
    }
    //#endregion
    /**
     * Возвращает `true`, если есть игра
     * @param matchID
     */
    hasGame(matchID) {
        return this.tables.getData(matchID) !== null;
    }
    /**
     * Возвращает `true`, если есть игра и данные по ней
     * @param matchID
     */
    hasGameData(matchID) {
        if (!this.hasGame(matchID)) {
            return false;
        }
        const data = this.tables.getData(matchID);
        return !!data && Object.keys(data.coefs || {}).length !== 0;
    }
    /**
     * true, если есть статистический матч
     * @param matchID
     */
    hasGameStatisctic(matchID) {
        return this.statistical_tables.getData(matchID) !== null;
    }
    /**
     * `true`, если есть стат. матч и данные по нему
     * @param matchID
     */
    hasGameDataStatisctic(matchID) {
        if (!this.hasGameStatisctic(matchID)) {
            return false;
        }
        const data = this.statistical_tables.getData(matchID);
        return !!data && Object.keys(data.coefs || {}).length !== 0;
    }
    clear() {
        this.categories.clear();
        // this.statistical_categories.clear();
        this.headTable.clear();
        this.tables.clear();
        // this.statistical_tables.clear();
    }
    /**
     * Очистить данные по событию
     * Т.е в случае, если событие завершилось,
     * данные очищаются, id остается, отображение скрывается
     * @param matchID
     */
    clearGame(matchID) {
        // this.description.clearGame(matchID);
        this.categories.clearGame(matchID);
        // this.statistical_categories.clearGame(matchID);
        this.headTable.clearGame(matchID);
        this.tables.clearGame(matchID);
        // this.statistical_tables.clearGame(matchID);
    }
    /**
     * Удалить событие: данные + id
     * Обновлением и отображением события больше не занимаемся
     * @param {string} matchID
     */
    deleteGame(matchID) {
        // this.description.deleteGame(matchID);
        this.categories.deleteGame(matchID);
        // this.statistical_categories.deleteGame(matchID);
        this.headTable.deleteGame(matchID);
        this.tables.deleteGame(matchID);
        // this.statistical_tables.deleteGame(matchID);
    }
    updateStatistic(matchID, sportID, data) {
        this.statistic_types.update(matchID, data.statsTypes || []);
        const statTypeBlStates = objectFromEntries(objectEntries(data.statsMatches || {})
            .filter(([, state]) => 'bl' in state)
            .map(([matchID, state]) => [matchID, state.bl === LOCK_STATE.BLOCKED || state.additionalOdds === null && state.categories === null]));
        this.statistic_types.disable(matchID, statTypeBlStates);
        objectEntries(data.statsMatches || {}).forEach(([matchID, state]) => {
            this.statistical_tables.update(Number(matchID), sportID, 'bl' in state ? { isDisabled: state.bl === LOCK_STATE.BLOCKED } : {}, state.tables, (state.tablesData || {}).tables, state.odds);
            this.statistical_categories.update(Number(matchID), sportID, {}, //{ isDisabled: state.bl === LOCK_STATE.BLOCKED },
            state.categories, (state.tablesData || {}).categories, []);
        });
    }
}
export class OutcomesDesktop extends OutcomesBase {
    constructor(cfg) {
        super(cfg);
        this.wsListener = new LiveOutcomesTable({
            site: cfg.siteType || SITE_TYPE.COM,
            timezone: cfg.timezone,
            lng: cfg.lng,
        });
        this.statistical_categories = new FavoriteCategories(this.width, this.statistical_tables.select, this.statistical_tables.favorite, this.statistical_tables.getFavoriteTables);
        this.categories = new FavoriteCategories(this.width, this.tables.select, this.tables.favorite, this.tables.getFavoriteTables);
    }
    update(matchID, data) {
        const config = 'bl' in data ? { isDisabled: data.bl === LOCK_STATE.BLOCKED } : {};
        /**
         * таблицы обновляются первыми, т.к содержат данные по коэф.
         */
        this.tables.update(matchID, data.sportId, config, data.bodyTables, (data.tablesData || {}).tables, data.odds);
        this.headTable.update(matchID, config, data);
        this.updateStatistic(matchID, data.sportId, data);
        this.categories.update(matchID, data.sportId, {}, data.categories, (data.tablesData || {}).categories, data.defaultCategories);
    }
}
export class OutcomesMobile extends OutcomesBase {
    constructor(cfg) {
        super(cfg);
        this.wsListener = new LiveOutcomesTableMobile({
            site: cfg.siteType || SITE_TYPE.COM,
            timezone: cfg.timezone,
            lng: cfg.lng,
        });
    }
    update(matchID, data) {
        const config = 'bl' in data ? { isDisabled: data.bl === LOCK_STATE.BLOCKED } : {};
        /**
         * таблицы обновляются первыми, т.к содержат данные по коэф.
         */
        this.tables.update(matchID, data.sportId, config, data.tables, (data.tablesData || {}).tables, data.odds, data.additionalOdds, data.expandedTables);
        this.updateStatistic(matchID, data.sportId, data);
        this.categories.update(matchID, data.sportId, {}, data.categories, (data.tablesData || {}).categories, data.defaultCategories);
    }
}
export class OutcomesMobileLine extends OutcomesBase {
    constructor(cfg) {
        super(cfg);
        this.wsListener = new LineOutcomesTableMobile({
            site: cfg.siteType || SITE_TYPE.COM,
            timezone: cfg.timezone,
            lng: cfg.lng,
        });
    }
    update(matchID, data) {
        const config = 'bl' in data ? { isDisabled: data.bl === LOCK_STATE.BLOCKED } : {};
        /**
         * таблицы обновляются первыми, т.к содержат данные по коэф.
         */
        this.tables.update(matchID, data.sportId, config, data.tables, (data.tablesData || {}).tables, data.odds, data.additionalOdds, data.expandedTables);
        this.updateStatistic(matchID, data.sportId, data);
        this.categories.update(matchID, data.sportId, {}, data.categories, (data.tablesData || {}).categories, data.defaultCategories);
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/line/Outcomes.js